// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LMLoggerService } from '@services/lm-logger.service';
import * as urltemplate from 'url-template';

@Injectable()
export class LMFieldOptionsService {
  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService
  ) {
  }

  /*
   *      fieldId - the encoded field id of the field that is initiating the initial value request.
   *      da*!/taView - the dataview for the record where the initial value is to be executed against.
   */
  public getFieldHistory(fieldId: string, dataView: LMDataView, formUrlInfo: LMFormUrlInfo, formSpec: LMFormSpec): Observable<any> {
    const formRequestUrlTemplate = urltemplate.parse(formUrlInfo.formRequestUrl);
    const resourceId = dataView.resourceId + '.' + (formSpec.busFormSpec?.name ? formSpec.busFormSpec.name : formSpec.busClassSpec.name);
    const formRequestUrl = formRequestUrlTemplate.expand({ resourceId });

    const postContent = {
      action:      dataView.action,
      dataView,
      fieldId,
      requestType: 'fieldHistory'
    };

    return this.http
      .post(formRequestUrl, postContent).pipe(
        catchError(error => this.handleError(error)));
  }

  public getPendingChanges(fieldId: string, dataView: LMDataView, formUrlInfo: LMFormUrlInfo, formSpec: LMFormSpec): Observable<any> {
    const formRequestUrlTemplate = urltemplate.parse(formUrlInfo.formRequestUrl);
    const resourceId = dataView.resourceId + '.' + (formSpec.busFormSpec?.name ? formSpec.busFormSpec.name : formSpec.busClassSpec.name);
    const formRequestUrl = formRequestUrlTemplate.expand({ resourceId });

    const postContent = {
      action:      dataView.action,
      dataView,
      fieldId,
      requestType: 'fieldPendingChanges'
    };

    return this.http
      .post(formRequestUrl, postContent).pipe(
        catchError(error => this.handleError(error)));
  }

  private handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }
}
